const copySubAdv = {
    holder: document.querySelectorAll('.jsSidebarAdvert')  as NodeListOf<HTMLElement>,   
    advert: document.getElementById('getInTachAdv') as HTMLElement,   

    init() {
       this.setAdvert();

    },
    setAdvert() {
        const html = this.advert.outerHTML;
        const img = this.advert.dataset.img;

        this.holder.forEach(item=>{
            item.innerHTML = html;         
            item.style.backgroundImage = `url(${img})`;
        })
    }

}

export default copySubAdv;